import React from "react";

// A title reads as no initial: « Dr Marie Dupont » gives « MD ».
const TITLE = /^Dr\.?$/;

// Initials are letters and digits only: « [TEST CRM] Alpha » gives « TC ».
const initialsOf = (name, count) => {
  const words = (name || "").split(/[\s-]+/).filter(Boolean);
  const named =
    words.length > 1 && TITLE.test(words[0]) ? words.slice(1) : words;
  const initials = named
    .map((w) => w.replace(/[^\p{L}\p{N}]/gu, ""))
    .filter(Boolean)
    .map((w) => w[0])
    .join("")
    .slice(0, count)
    .toUpperCase();
  return initials || "?";
};

const Avatar = ({ name, size = 28, className = "" }) => {
  const initials = initialsOf(name, size > 36 ? 2 : 1);
  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center rounded-full bg-surfaceMuted font-medium text-body ${className}`}
      style={{ width: size, height: size, fontSize: size > 36 ? 14 : 12 }}
    >
      {initials}
    </span>
  );
};

export default Avatar;
